import { RadioConfig, RadioState, VolumeScaleType } from "./types";

export const ALL_RADIOS = ["GLOBAL", "CABIN"] as const;

export const ALL_STATIONS = [
	"RADIO_GUITAR_LOFI_01",
	"RADIO_GUITAR_LOFI_02",
	"RADIO_GUITAR_LOFI_03",
	"RADIO_GUITAR_LOFI_04",
	"RADIO_GUITAR_LOFI",
	"RADIO_TEST",
] as const;
export interface VolumeScale {
	numberOfSteps: number;
	maxGain: number;
	scaleType: VolumeScaleType;
}

export const generateVolumeSteps = (config: VolumeScale): number[] => {
	const { numberOfSteps, maxGain, scaleType } = config;
	const roundTo = 100;

	if (numberOfSteps <= 0) {
		return [0];
	}

	return Array.from({ length: numberOfSteps + 1 }, (_, i) => {
		if (i === 0) return 0;

		const normalizedStep = i / numberOfSteps;
		let gain: number;
		switch (scaleType) {
			case "linear":
				gain = maxGain * normalizedStep;
				break;
			case "logarithmic":
				// AI Generated coeffeicient... sorry
				gain = maxGain * Math.log(1 + normalizedStep * (Math.E - 1));
				break;
			default:
				gain = maxGain;
				break;
		}
		return Math.round(gain * roundTo) / roundTo;
	});
};
export const DEFAULT_RADIO_CONFIG: RadioConfig = {
	numberOfSteps: 5,
	maxGain: 1,
	scaleType: "logarithmic",
};

export const DEFAULT_RADIO_STATE: RadioState = {
	isOn: false,
	station: "RADIO_GUITAR_LOFI",
	gain: 1,
	volumeLevel: generateVolumeSteps(DEFAULT_RADIO_CONFIG).length - 1,
	config: DEFAULT_RADIO_CONFIG,
};
